export default "__VITE_ASSET__QTUUljf5__"